import { useEffect } from "react";
import { useLocation } from "react-router";

export function useScrollToHash(isEnabled = true): void {
  const location = useLocation();

  useEffect(() => {
    if (!isEnabled || !location.hash) {
      return;
    }

    const hashValue = location.hash.slice(1);
    const elementId = decodeURIComponent(hashValue);

    // Timeout is needed to ensure the parent component is mounted before trying to scroll to the element
    const id = setTimeout(() => {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);

    return () => clearTimeout(id);
  }, [isEnabled, location.hash]);
}
